<template>
  <vs-popup
    class="show-taste-panel-result-popup"
    :title="'Taste Panel Result - ' + (tastingGroupResult.code || '')"
    :active.sync="open"
    :buttons-hidden="true"
    @close="closePopup"
  >
    <vx-card no-shadow>
      <div v-if="tastingGroupResult && tastingGroupResult.id">
        <!-- Panel Information -->
        <div class="mb-8">
          <div class="text-sm font-semibold mb-4">Panel Information</div>

          <div class="grid grid-cols-2 gap-4 text-sm">
            <div>
              <div class="font-semibold mb-1">Created At</div>
              <div>
                {{
                  tastingGroupResult.created_at
                    ? __dateTimeFormatter(tastingGroupResult.created_at)
                    : "-"
                }}
              </div>
            </div>

            <div>
              <div class="font-semibold mb-1">Last Updated</div>
              <div>
                {{
                  tastingGroupResult.updated_at
                    ? __dateTimeFormatter(tastingGroupResult.updated_at)
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <!-- Staff -->
        <div class="mb-8">
          <div class="text-sm font-semibold mb-3">Allocated Staff</div>

          <div
            v-if="tastingGroupResult.staff.length"
            class="flex flex-wrap gap-2 text-sm"
          >
            <div
              v-for="staff in tastingGroupResult.staff"
              :key="staff.id"
              class="px-3 py-1 border rounded"
            >
              {{ staff.name }}
            </div>
          </div>

          <div v-else class="text-sm">No staff allocated.</div>
        </div>

        <!-- Results -->
        <div>
          <div class="text-sm font-semibold mb-4">RM Batch Results</div>

          <div class="grid grid-cols-1 gap-4">
            <vx-card
              v-for="(item, index) in inventories"
              :key="index"
              class="shadow-sm"
            >
              <div
                class="flex items-center justify-between cursor-pointer"
                @click="toggleBatch(index)"
              >
                
                <div class="flex items-center gap-3">
                  <vs-icon
                    :icon="openBatches[index] ? 'expand_more' : 'chevron_right'"
                    size="small"
                  />

                  <span class="text-sm font-semibold">
                    {{ item.code }}
                  </span>
                </div>

              
                <div class="flex items-center justify-end gap-6 flex-1">

                  <template v-if="showSignOffButton(item)">
                    <div class="text-xs text-right">
                      <div class="font-semibold">Sign off By</div>
                      <div>{{ getSignOffBy(item) }}</div>
                    </div>

                    <div class="text-xs text-right">
                      <div class="font-semibold">Sign off Result</div>
                      <div>{{ getStatusForInventory(item) }}</div>
                    </div>

                    <vx-tooltip text="Sign off / Update" position="top">
                      <vs-button
                        type="border"
                        size="small"
                        icon-pack="material-icons"
                        icon="edit"
                        @click.stop="openSignOffPopup(item.id, item)"
                      />
                    </vx-tooltip>

                    <vx-tooltip text="Add / View Attachments" position="top">
                      <vs-button
                        type="border"
                        size="small"
                        color="warning"
                        icon-pack="material-icons"
                        icon="attach_file"
                        @click.stop="openAttachmentPopup(item.id, item.code)"
                      />
                    </vx-tooltip>
                  </template>

                 
                  <small
                    v-if="!showSignOffButton(item)"
                    class="text-warning"
                  >
                    At least one staff needs to complete the panel to sign off
                  </small>

                 
                  <vx-tooltip
                    text="View Last Tested Batch Details"
                    position="top"
                    v-if="item.pivot && item.pivot.last_tested_batch !== null"
                  >
                    <vs-button
                      type="border"
                      size="small"
                      color="success"
                      icon-pack="feather"
                      icon="icon-eye"
                      @click.stop="openLastTestedBatchPopup(item)"
                    />
                  </vx-tooltip>

                </div>
              </div>

              <div v-if="openBatches[index]" class="mt-4">
                <vs-table :data="tastingGroupResult.staff">
                  <template slot="thead">
                    <vs-th>Staff</vs-th>
                    <vs-th>Staff Panel Status</vs-th>
                    <vs-th>Appearance</vs-th>
                    <vs-th>Odour</vs-th>
                    <vs-th>Taste</vs-th>
                    <vs-th>Notes</vs-th>
                    <!-- <vs-th>Attachments</vs-th> -->
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr v-for="(staff, idx) in data" :key="idx">
                      <template
                        v-if="(tasting = getMemberTasting(item, staff))"
                      >
                        <vs-td>{{ staff.name }}</vs-td>

                        <vs-td>Completed</vs-td>

                        <vs-td>{{
                          getResultText(tasting, "Appearance")
                        }}</vs-td>
                        <vs-td>{{ getResultText(tasting, "Odour") }}</vs-td>
                        <vs-td>{{ getResultText(tasting, "Taste") }}</vs-td>

                        <vs-td>{{ tasting.notes ? tasting.notes : "-" }}</vs-td>

                        <!-- <vs-td>
                          <div
                            v-if="
                              tasting.file_paths && tasting.file_paths.length
                            "
                          >
                            <div
                              v-for="(file, i) in tasting.file_paths"
                              :key="i"
                            >
                              <a
                                :href="file"
                                target="_blank"
                                class="text-primary text-xs underline"
                              >
                                View File {{ i + 1 }}
                              </a>
                            </div>
                          </div>
                          <div v-else class="text-xs">-</div>
                        </vs-td> -->
                      </template>

                      <template v-else>
                        <vs-td>{{ staff.name }}</vs-td>
                        <vs-td>Pending Complete</vs-td>
                        <vs-td>-</vs-td>
                        <vs-td>-</vs-td>
                        <vs-td>-</vs-td>
                        <vs-td>-</vs-td>
                        <vs-td>-</vs-td>
                      </template>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vx-card>
          </div>
        </div>
        <div v-if="tastingGroupResult.work_orders.length" class="mt-10">
          <div class="text-sm font-semibold mb-4">Work Order Results</div>

          <div class="grid grid-cols-1 gap-4">
            <vx-card
              v-for="(item, index) in tastingGroupResult.work_orders"
              :key="'wo-' + index"
              class="shadow-sm"
            >
              <div
                class="flex items-center justify-between cursor-pointer"
                @click="toggleBatch('wo-' + index)"
              >
                <div class="flex items-center gap-3">
                  <vs-icon
                    :icon="
                      openBatches['wo-' + index]
                        ? 'expand_more'
                        : 'chevron_right'
                    "
                    size="small"
                  />
                  <span class="text-sm font-semibold">
                    {{ item.work_order_code }}
                  </span>
                </div>

                <div class="flex items-center justify-end gap-6 flex-1">
                  <div class="text-xs text-right">
                    <div class="font-semibold">Sign off By</div>
                    <div>{{ getSignOffBy(item) }}</div>
                  </div>
                  <div class="text-xs text-right">
                    <div class="font-semibold">Sign off Result</div>
                    <div>{{ getStatusForInventory(item) }}</div>
                  </div>

                  <vx-tooltip
                    text="Approve/Reject"
                    position="top"
                    v-if="showSignOffButton(item)"
                  >
                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="material-icons"
                      icon="edit"
                      @click.stop="openSignOffPopup(item.id, item)"
                    />
                  </vx-tooltip>
                  <vx-tooltip
                    text="View Last Tested WO Details"
                    position="top"
                    v-if="item.pivot && item.pivot.last_tested_batch !== null"
                  >
                    <vs-button
                      type="border"
                      size="small"
                      color="success"
                      icon-pack="feather"
                      icon="icon-eye"
                      @click.stop="openLastTestedBatchPopup(item)"
                    />
                  </vx-tooltip>
                </div>
              </div>

              <!-- Body -->
              <div v-if="openBatches['wo-' + index]" class="mt-4">
                <vs-table :data="tastingGroupResult.staff">
                  <template slot="thead">
                    <vs-th>Staff</vs-th>
                    <vs-th>Staff Panel Status</vs-th>
                    <vs-th>Appearance</vs-th>
                    <vs-th>Odour</vs-th>
                    <vs-th>Taste</vs-th>
                    <vs-th>Notes</vs-th>
                    <!-- <vs-th>Attachments</vs-th> -->
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr v-for="(staff, idx) in data" :key="idx">
                      <template
                        v-if="(tasting = getMemberTasting(item, staff))"
                      >
                        <vs-td>{{ staff.name }}</vs-td>

                        <vs-td>Completed</vs-td>

                        <vs-td>{{
                          getResultText(tasting, "Appearance")
                        }}</vs-td>
                        <vs-td>{{ getResultText(tasting, "Odour") }}</vs-td>
                        <vs-td>{{ getResultText(tasting, "Taste") }}</vs-td>

                        <vs-td>{{ tasting.notes ? tasting.notes : "-" }}</vs-td>

                        <!-- <vs-td>
                          <div
                            v-if="
                              tasting.file_paths && tasting.file_paths.length
                            "
                          >
                            <div
                              v-for="(file, i) in tasting.file_paths"
                              :key="i"
                            >
                              <a
                                :href="file"
                                target="_blank"
                                class="text-primary text-xs underline"
                              >
                                View File {{ i + 1 }}
                              </a>
                            </div>
                          </div>
                          <div v-else class="text-xs">-</div>
                        </vs-td> -->
                      </template>

                      <template v-else>
                        <vs-td>{{ staff.name }}</vs-td>
                        <vs-td>Pending Complete</vs-td>
                        <vs-td>-</vs-td>
                        <vs-td>-</vs-td>
                        <vs-td>-</vs-td>
                        <vs-td>-</vs-td>
                        <vs-td>-</vs-td>
                      </template>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vx-card>
          </div>
        </div>
        <vx-card no-shadow :card-border="true" class="mt-4">
          <h6 class="font-semibold text-base mb-2 pb-2 border-b">
            Attachments
          </h6>

          <FilePreviewGallery
            :files="filePaths"
            @remove="removeFile"
            :removable="true"
            class="mb-2"
          />

          <multi-file-uploader
            v-on:onSetFileName="onSetFiles($event)"
            :file="''"
            file_path="taste-panel/attachments"
            :condition="true"
          />
        </vx-card>

        <!-- Footer -->
        <div class="flex justify-end mt-8">
          <vs-button type="border" @click="closePopup"> Close </vs-button>
        </div>
      </div>

      <div v-else class="text-center py-10">No tasting results available.</div>
    </vx-card>

    <signOffTastePanel ref="signOffTastePanel" @refresh="refresh" />
    <rm-batch-taste-panel-attachments ref="rmBatchTastePanelAttachments"/>
    <ShowBatchWoTpResult ref="showBatchWoTpResult"/>
  </vs-popup>
</template>
<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import signOffTastePanel from "./signOffTastePanel.vue";
import FilePreviewGallery from "@/components/shared/FilePreviewGallery.vue";
import RmBatchTastePanelAttachments from "@/components/popups/inventory/rm-orders/rm-batches/RmBatchTastePanelAttachments.vue";
import ShowBatchWoTpResult from "@/components/popups/TastePanel/ShowBatchWoTpResult.vue";
const TriangleTestsRepository = RepositoryFactory.get("triangle_tests");

export default {
  name: "ShowTastePanelResultPopUp",

  data() {
    return {
      open: false,
      tastingGroupId: null,
      tastingGroupResult: {},
      openBatches: {},
      filePaths: [],
    };
  },
  components: {
    signOffTastePanel,
    FilePreviewGallery,
    RmBatchTastePanelAttachments,
    ShowBatchWoTpResult,
  },

  computed: {
    inventories() {
      return this.tastingGroupResult.raw_material_stock_inventories || [];
    },

    // Get unique panel member names across all inventories
    panelMembers() {
      const members = new Set();

      this.inventories.forEach((inv) => {
        if (inv.quality_control_tastings) {
          inv.quality_control_tastings.forEach((test) => {
            if (test.done_by && test.done_by.name) {
              members.add(test);
            }
          });
        }
      });

      return Array.from(members);
    },
  },

  methods: {
    getStatusForMember(inventory, memberName) {
      if (!inventory.quality_control_tastings) return "-";

      const tasting = inventory.quality_control_tastings
        .slice()
        .reverse() // get latest first
        .find((t) => t.done_by && t.done_by.name === memberName);

      return tasting ? "completed" : "Not completed";
    },

    getMemberTasting(inventory, staff) {
      if (!inventory.quality_control_tastings.length) return null;

      return (
        inventory.quality_control_tastings.find(
          (t) => t.done_by && t.done_by.id === staff.id
        ) || null
      );
    },

    openAttachmentPopup(id, code){
      this.$refs.rmBatchTastePanelAttachments.openPopup(id, code);
    },

    async removeFile(index) {
      this.filePaths.splice(index, 1);
      await this.updateTastingGroupFiles();
    },

    async onSetFiles(file_path) {
      this.filePaths.push(file_path);
      await this.updateTastingGroupFiles();
    },

    async updateTastingGroupFiles() {
      const payload = {
        file_paths: this.filePaths,
      };
      try {
        await TriangleTestsRepository.updateTastingGroupFiles(
          this.tastingGroupId,
          payload
        );
      } catch (error) {}
    },

    openLastTestedBatchPopup(item){
      this.$refs.showBatchWoTpResult.openPopup(item.pivot.last_tested_batch, item.pivot.groupable_type);
    },

    getResultText(tasting, field) {
      if (!tasting) return "-";
      const properties = tasting.properties ? tasting.properties : [];
      if (properties.length) {
        const property = properties.find((p) => p.name === field);
        return property ? `${property.comment} (${property.status})` : "-";
      }
      return "-";
    },

    toggleBatch(key) {
      this.$set(this.openBatches, key, !this.openBatches[key]);
    },
    showSignOffButton(item) {
      return item.quality_control_tastings.length > 0;
    },
    getStatusForInventory(inventory) {
      const signOff = inventory.quality_control_batch_sign_off.find(
        (x) => x.group_id === this.tastingGroupId
      );
      if (signOff) {
        return signOff.status;
      }
      return "Pending Review";
    },

    getSignOffBy(inventory) {
      const signOff = inventory.quality_control_batch_sign_off.find(
        (x) => x.group_id === this.tastingGroupId
      );
      if (signOff) {
        return `${signOff.signed_by.name} (${this.__dateTimeFormatterToDate(
          signOff.signed_at
        )})`;
      }
      return "Pending Review";
    },

    async openPopUp(id) {
      this.tastingGroupId = id;
      await this.getTastingGroupResult();
      await this.getTastingGroupFiles();
      this.open = true;
    },
    async getTastingGroupResult() {
      try {
        this.$vs.loading();

        const response = await TriangleTestsRepository.getTastingGroupResult(
          this.tastingGroupId
        );

        this.tastingGroupResult = response.data.data;
      } catch (e) {
        this.$vs.notify({
          title: "Error",
          text: "Failed to fetch tasting group result",
          color: "danger",
          icon: "error",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async getTastingGroupFiles() {
      try {
        const response = await TriangleTestsRepository.getTastingGroupFiles(
          this.tastingGroupId
        );
        this.filePaths = response.data.data ? response.data.data : []
      } catch (e) {
      }
    },

    async refresh() {
      await this.getTastingGroupResult();
      await this.getTastingGroupFiles();
    },

    openSignOffPopup(id, item) {
      this.$refs.signOffTastePanel.openPopup(this.tastingGroupResult, item);
    },

    closePopup() {
      this.open = false;
    },
  },
};
</script>
<style scoped>
.show-taste-panel-result-popup >>> .vs-popup {
  min-width: 80% !important;
}
</style>
